import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f4f4f4',
                textAlign: 'center',
                px: 2,
            }}
        >
            <Container maxWidth="sm">
                <Typography
                    variant="h1"
                    component="h1"
                    sx={{
                        fontSize: { xs: '6rem', md: '8rem' },
                        fontWeight: 800,
                        color: 'primary.main',
                        textShadow: '2px 2px 8px rgba(0,0,0,0.1)',
                    }}
                >
                    404
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                        mt: -2,
                        mb: 2,
                        fontWeight: 600,
                        color: 'text.secondary',
                    }}
                >
                    Page Not Found
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 4 }}
                >
                    Sorry, the page you are looking for does not exist. It might have been moved or deleted.
                </Typography>
                <Button
                    component={Link}
                    to="/"
                    variant="contained"
                    size="large"
                    sx={{
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    }}
                >
                    Go Back to Home
                </Button>
            </Container>
        </Box>
    );
}

export default NotFound;
